import {
  isDefinedArray,
  isNullOrUndefined,
  isPositiveNumber
} from "et3-type-guards";
import { memoize } from "lodash";
import orderBy from "lodash/orderBy";
import { computed, observable, runInAction } from "mobx";

import { apiCallGetSupervisedAuditEvents } from "../../../api/supervisor-api/api-call-get-supervised-events";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { TSupervisedAuditEvent } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import i18n from "../../../constants/i18n";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class SupervisedEventsStore {
  supervisedAuditEvents = observable.box<TSupervisedAuditEvent[]>([]);
  adminInput = observable.box<TEt3PickerSingleValue>({
    value: "",
    label: i18n.get("CHOOSE")
  });
  dateMinInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 1, daysAdded: 0 })
  );
  dateMaxInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  limitInput = observable.box<TEt3PickerSingleValue>({
    label: "50",
    value: "50"
  });
  typeInputSupervisedEvent = observable.box<TEt3PickerSingleValue>({
    label: "all",
    value: "all"
  });
  typeInputSupervisedIssue = observable.box<TEt3PickerSingleValue>({
    label: "all",
    value: "all"
  });

  supervisedAuditEventsOrdered = computed(() => {
    const supervisedAuditEventsOrdered = orderBy(
      this.supervisedAuditEvents.get(),
      ["supervised_on"],
      ["desc"]
    );
    const finalizedArray = supervisedAuditEventsOrdered.map((data) => {
      return {
        ...data,
        event_id: data.id,
        supervised_extra_data: {
          suppervisedDataType: data.type,
          supervisedExtraData: data.extra_data,
          supervisedPageName: data.page_name
        },
        supervised_events_reasons: data.reasons
      };
    });
    return finalizedArray;
  });
  setAdmin = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.adminInput.set(admin);
    });
  };
  setTypeInputSupervisedEvent = (type: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.typeInputSupervisedEvent.set(type);
    });
  };
  setTypeInputSupervisedIssue = (type: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.typeInputSupervisedIssue.set(type);
    });
  };
  setLimitInput = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.limitInput.set(limit);
    });
  };
  getSupervisedEvents = async () => {
    const adminId = this.adminInput.get().value;
    const definedAdminID = reducerToZeroIfUndefined(parseInt(adminId, 10));
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.limitInput.get().value, 10)
    );

    if (!isPositiveNumber(definedAdminID) || !isPositiveNumber(definedLimit)) {
      return;
    }
    getCoreUIStore().setIsLoading("SUPERVISOR_SUPERVISED_EVENTS", true);

    const { data, status, code } = await apiCallGetSupervisedAuditEvents({
      adminId: definedAdminID,
      dateMin: this.dateMinInput.get(),
      dateMax: this.dateMaxInput.get(),
      limit: definedLimit,
      eventType: this.typeInputSupervisedEvent.get().value,
      issueType: this.typeInputSupervisedIssue.get().value
    });

    getCoreUIStore().setIsLoading("SUPERVISOR_SUPERVISED_EVENTS", false);
    if (status === "OK") {
      if (!isNullOrUndefined(data) && isDefinedArray(data)) {
        this.supervisedAuditEvents.set(data);
      } else {
        this.supervisedAuditEvents.set([]);
        getCorePopUpStore().showAlertMessage("EVENTS_NOT_FOUND");
      }
    } else {
      this.supervisedAuditEvents.set([]);
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}
export const getSupervisedEventsStore = memoize(
  () => new SupervisedEventsStore(),
  () => 1
);
